import { render, staticRenderFns } from "./TreRatioCard.vue?vue&type=template&id=1c8d8718&"
import script from "./TreRatioCard.vue?vue&type=script&lang=js&"
export * from "./TreRatioCard.vue?vue&type=script&lang=js&"
import style0 from "./TreRatioCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports